import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import {
  persistWaitlistJoined,
  readWaitlistState,
  WAITLIST_STORAGE_KEY,
} from "@/lib/waitlistStorage";

const WaitlistContext = createContext(null);

export function WaitlistProvider({ children }) {
  const [state, setState] = useState(() => readWaitlistState());

  const syncFromStorage = useCallback(() => {
    setState(readWaitlistState());
  }, []);

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === WAITLIST_STORAGE_KEY) syncFromStorage();
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, [syncFromStorage]);

  const markJoined = useCallback((addr) => {
    persistWaitlistJoined(addr);
    setState(readWaitlistState());
  }, []);

  const value = useMemo(
    () => ({
      joined: state.joined,
      email: state.email,
      markJoined,
    }),
    [state.joined, state.email, markJoined]
  );

  return (
    <WaitlistContext.Provider value={value}>{children}</WaitlistContext.Provider>
  );
}

export function useWaitlist() {
  const ctx = useContext(WaitlistContext);
  if (!ctx) {
    throw new Error("useWaitlist must be used within WaitlistProvider");
  }
  return ctx;
}
